import React, { useState, useCallback } from "react";
import { observer } from "mobx-react";
import { TextField } from "@ann/web-components";
import { 
  FiltersContainer, 
  FiltersLeftContent, 
  FiltersRightContent,
  SearchContainer 
} from "./Filters.styled";

const Filters = observer(() => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = useCallback((value) => {
    setSearchValue(value);
    // TODO: Add search callback here if needed
    // to update the parent component's state
  }, []);

  return (
    <FiltersContainer>
      <FiltersLeftContent>
        <SearchContainer>
          <TextField
            iconLeft="search"
            onChange={handleSearchChange}
            size="small"
            placeholder="Search activities..."
            value={searchValue}
          />
        </SearchContainer>
      </FiltersLeftContent>
      <FiltersRightContent>
        {/* Additional filters can be added here in the future */}
      </FiltersRightContent>
    </FiltersContainer>
  );
});

export default Filters; 